import { useCallback, useEffect, useRef, useState } from "react";
import { SearchableDropdownContainer } from "./SearchableDropdownContainer";
import { COUNTRY_CDN_URL } from "../../../../utils/constant";
import { SearchableDropdowns } from "./FormComponentSchema";
import { CountryLists } from "../../../../pages/Contact/EditContact/EditContactSchema";

const SearchableDropdown :React.FC<SearchableDropdowns> = ({
  // isCountryDropdownOpen,
  setIsCountryDropdownOpen,
  placeholder,
  options,
  label1,
  label2,
  label3,
  id,
  selectedVal,
  handleChange,
  isOpen,
  setIsOpen,
  inputRef,
}) => {
  const [query, setQuery] = useState("");
 

  const inputRef2 = useRef(null);
 
  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => {
      document.removeEventListener("click", toggle);
    };
  }, []); 
  const selectOption = (option : CountryLists) => {
    setQuery(() => "");
    handleChange(option);
    setIsOpen((isOpen) => !isOpen);
    setIsCountryDropdownOpen((isOpen) => !isOpen);
  };
   
  const toggle = useCallback((e: MouseEvent | React.MouseEvent<HTMLInputElement>) => {
    const target = e.target as HTMLElement;
    if (!e.target) return; 
    setIsOpen(
      (e.target === inputRef.current) || 
      (e.target === inputRef2.current) || target.classList.contains("img_flag")
    );
  }, []);
  

  // const getDisplayValue = () => {
  //   if (query) return query;

  //   if (selectedVal) return selectedVal;

  //   return "";
  // };

  const filter = (options : CountryLists[] ) => {
    return options.filter(
      (option) => String(option[label1 as keyof CountryLists]).toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  };
  return (
    <SearchableDropdownContainer>
      <div className="dropdown">
        <div className="control">
          <div className="selected-value">
            <input
              placeholder={placeholder}
              ref={inputRef2}
              type="text"
              // value={getDisplayValue()}
              name="searchTerm"
              onChange={(e) => {
                setQuery(e.target.value);
                // handleChange(e.target.value);
              }}
              onClick={toggle}
            />
          </div>
          <div className={`arrow ${isOpen ? "open" : ""}`}></div>
        </div>

        <div className={`options ${isOpen ? "open" : ""}`}>
          {filter(options).map((option, index) => {
             
            return (
              <div
                onClick={() => selectOption(option)}
                className={`d-flex align-items-center option ${
                  option[label1 as keyof CountryLists] === selectedVal ? "selected" : ""
                }`}
                key={`${id}-${index}`}
              >
                <img
                  className="country_flag_img"
                  src={`${COUNTRY_CDN_URL}/${option[label3 as keyof CountryLists]}`}
                />
                <h6>{option[label1 as keyof CountryLists]}</h6>
                <h6 className="country_code">{option[label2 as keyof CountryLists]}</h6>
              </div>
            );
          })}
        </div>
      </div>
    </SearchableDropdownContainer>
  );
};

export default SearchableDropdown;
